import { useBreakpoint } from 'app/spacing';
import { useTranslation } from 'react-i18next';
import { usePaginationSettings } from 'hooks/usePaginationSettings';
import { HistoryModal } from 'components/Modals/HistoryModal';
import { useColumns } from 'components/Modals/HistoryModal/hooks';
import { keepPreviousData, useQuery } from '@tanstack/react-query';
import { automationHistoryQuery } from 'query/automation';
import { DEFAULT_PAGINATION_SETTINGS } from './constants';

export const AutomationHistoryModal = ({ automation, modalProps }) => {
  const { t } = useTranslation();
  const isMobile = useBreakpoint();

  const pagination = usePaginationSettings(DEFAULT_PAGINATION_SETTINGS);
  const { page, pageSize, ordering, search } = pagination;
  const queryParams = {
    page,
    page_size: pageSize,
    ordering,
    search,
  };
  const historyQuery = useQuery(
    automationHistoryQuery(automation.id, {
      enabled: !!automation.id,
      params: queryParams,
      placeholderData: keepPreviousData,
      staleTime: 0,
    })
  );
  const columns = useColumns();
  return isMobile ? null : (
    <HistoryModal
      {...modalProps}
      heading={t('Automation History Log')}
      loading={historyQuery.isLoading}
      results={historyQuery.data?.results ?? []}
      columns={columns}
      count={historyQuery.data?.count}
      pagination={pagination}
      showSearch
    />
  );
};
